// Generated DB Item type: PatientEncounter
export * from './types.js';
export * from './db-def.js';
//# sourceMappingURL=index.js.map